{
    "websiteName": "historia.ro",
    "websitePushID": "web.historia-ro.adh.reperio.news",
    "allowedDomains": [
        "https://historia.ro",
        "https://www.historia.ro"
    ],
    "urlFormatString": "https://historia.ro/%@",
    "authenticationToken": "19f8d7a6e9fb8a7f6d9330dabe",
    "webServiceURL": "https://historia.ro/apple_webpush"
}
